import React from 'react'
import { Grid } from '@material-ui/core'

function ServerError(props) {
  return(
    <Grid container justify="center" spacing={2}>
      <Grid item xs={4}>
        <h3 style={{ textAlign: 'center', color: '#b6b6b6' }}>There was an error encountered. Please contact Support Team.</h3>
      </Grid>
    </Grid>
  )
}

export default ServerError;